import { roles } from 'roles';

const endpoints = {
  local: {
    apiURI: 'https://h5n9jppc5l.execute-api.eu-west-1.amazonaws.com/dev',
    s3Bucket: 'dev-mobilize-documents',
    oidc: {
      // OIDC IS BY-PASSED ON LOCAL ENV ! These values are NOT used
      authority: 'https://idp2.renault.com/nidp/oauth/nam',
      loginUrl: 'https://idp2.renault.com/nidp/oauth/nam/authz',
      userinfoEndpoint: 'https://idp2.renault.com/nidp/oauth/nam/userinfo',
      clientId: '62e1e407-9291-4c1b-9721-06fd4be2af63',
      clientSecret: 'G1FKMPwFdVRDpNxzT_5QTZXCLAi4coVRRkFHxHzYOjybhZa91IZzhzSPRnL1SzMNouU5YBoGIpFyj2HAF0AGuw',
      redirectUri: 'https://localhost:3000/',
      responseType: 'code',
    },
    oidcVectury: {
      scope: 'openid vectury-userX role-rnet-efo-irn73161',
    },
    oidcArca: {
      scope: 'openid arcaX',
    },
    auth: {
      userData: {
        profile: {
          given_name: 'Emmanuel',
          family_name: 'Lambert',
          email: 'emmanuel.lambert-extern@renault.com',
          uid: 'p111018',
        },
        access_token: process.env.REACT_APP_DEFAULT_ACCESSTOKEN,
      },
    },
    loginAuth: {
      endpoint: 'https://to4pm3aah9.execute-api.eu-west-3.amazonaws.com/dev',
      xApiKey: process.env.REACT_APP_XAPIKEY,
    },
  },
  development: {
    apiURI: 'https://h5n9jppc5l.execute-api.eu-west-1.amazonaws.com/dev',
    s3Bucket: 'dev-mobilize-documents',
    oidc: {
      // OIDC IS BY-PASSED ON DEV ENV ! These values are NOT used
      authority: 'https://idp2.renault.com/nidp/oauth/nam',
      loginUrl: 'https://idp2.renault.com/nidp/oauth/nam/authz',
      userinfoEndpoint: 'https://idp2.renault.com/nidp/oauth/nam/userinfo',
      clientId: '62e1e407-9291-4c1b-9721-06fd4be2af63',
      clientSecret: 'G1FKMPwFdVRDpNxzT_5QTZXCLAi4coVRRkFHxHzYOjybhZa91IZzhzSPRnL1SzMNouU5YBoGIpFyj2HAF0AGuw',
      redirectUri: 'https://d2hhiekactuocn.cloudfront.net/',
      responseType: 'code',
    },
    oidcVectury: {
      scope: 'openid vectury-userX role-rnet-efo-irn73161',
    },
    oidcArca: {
      scope: 'openid arcaX',
    },
    auth: {
      userData: {
        profile: {
          given_name: 'Emmanuel',
          family_name: 'Lambert',
          email: 'emmanuel.lambert-extern@renault.com',
          uid: 'p111018',
        },
        access_token: process.env.REACT_APP_DEFAULT_ACCESSTOKEN,
        renault_token:
          'eyJraWQiOiIxNzY3IiwidHlwIjoiSldUIiwiYWxnIjoiUlMyNTYifQ.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.JOpFmE9TxOiZ6CqXHcfSQNU6S4I7BPgG5BSslawUkXMuN8SmTWHWqkJdtONNC0hmKr1r3CUzc3E-OnbcGkkdPkkyS_nfWQlbcQETRwFL4iV5z2XSNyOqZngw9UnhJ9swoafrXrclRNxovJlJsHszyUS4f3jiM7MDLGM7ibaRXil5P8Nd_N6dRNOSBWO_ivkwuHfW1WljdtUeSPsOoGHFK5gZN7WPW2LmUB-fhqY8XF5dtrXMWrwTUilxj-HsGP0R0cY-KRo3lmRJF0MJhe8J1mAiClLr10W0744AIOVuuugcN-uiz1UfO28Zx0k-22FfxxdxL1XLTiSFscY8q9g9KQ',
      },
    },
    loginAuth: {
      endpoint: 'https://to4pm3aah9.execute-api.eu-west-3.amazonaws.com/dev',
      xApiKey: process.env.REACT_APP_XAPIKEY,
    },
  },
  qa: {
    apiURI: 'https://7ijq9c10d1.execute-api.eu-west-3.amazonaws.com/dev',
    s3Bucket: 'dev-mobilize-documents',
    oidc: {
      authority: 'https://idp2.renault.com/nidp/oauth/nam',
      loginUrl: 'https://idp2.renault.com/nidp/oauth/nam/authz',
      userinfoEndpoint: 'https://idp2.renault.com/nidp/oauth/nam/userinfo',
      clientId: '62e1e407-9291-4c1b-9721-06fd4be2af63',
      clientSecret: 'G1FKMPwFdVRDpNxzT_5QTZXCLAi4coVRRkFHxHzYOjybhZa91IZzhzSPRnL1SzMNouU5YBoGIpFyj2HAF0AGuw',
      redirectUri: 'https://d2hhiekactuocn.cloudfront.net/',
      responseType: 'code',
    },
    oidcVectury: {
      scope: 'openid vectury-userX role-rnet-efo-irn73161',
    },
    oidcArca: {
      scope: 'openid arcaX',
    },
    auth: {
      userData: {
        profile: {
          given_name: 'Emmanuel',
          family_name: 'Lambert',
          email: 'emmanuel.lambert-extern@renault.com',
          uid: 'p111018',
        },
        access_token: process.env.REACT_APP_DEFAULT_ACCESSTOKEN,
      },
    },
    loginAuth: {
      endpoint: 'https://lkb7okh3u9.execute-api.eu-west-3.amazonaws.com/uat',
      xApiKey: process.env.REACT_APP_XAPIKEY,
    },
  },
  production: {
    apiURI: 'https://zsvr2amelj.execute-api.eu-west-1.amazonaws.com/prod',
    s3Bucket: 'prd-mobilize-documents',
    oidc: {
      authority: 'https://idp.renault.com/nidp/oauth/nam',
      loginUrl: 'https://idp.renault.com/nidp/oauth/nam/authz',
      userinfoEndpoint: 'https://idp.renault.com/nidp/oauth/nam/userinfo',
      clientId: '200f206f-8872-4a4f-aae6-66c217db5c6e',
      clientSecret: process.env.REACT_APP_OIDC_SECRET,
      redirectUri: 'https://app-b2b.mobilize-power-solutions.com/',
      responseType: 'code',
    },
    oidcVectury: {
      scope: 'openid vectury-userX role-rnet-efo-irn73161',
    },
    oidcArca: {
      scope: 'openid arcaX',
    },
    auth: {
      userData: {
        profile: {
          given_name: 'Emmanuel',
          family_name: 'Lambert',
          email: 'emmanuel.lambert-extern@renault.com',
          uid: 'p111018',
        },
        access_token: process.env.REACT_APP_DEFAULT_ACCESSTOKEN,
      },
    },
    loginAuth: {
      endpoint: 'https://sykfzr79pe.execute-api.eu-west-3.amazonaws.com/prod',
      xApiKey: process.env.REACT_APP_XAPIKEY,
    },
  },
};
export const endpoint = endpoints['development'];
// export const endpoint = process.env.NODE_ENV === 'production' ? endpoints['production'] : endpoints['development'];
export const IS_AUTH_ENABLED = true;

export const documentLinks = {
  priceTemplate:
    'https://storage-elexent-images-20210712192123.s3.eu-west-3.amazonaws.com/dev/France/BPU_TEMPLATE.xlsx',
};

export const defaultAuthProvider = {
  hasAccessToUsers: true,
  groups: {
    [roles.administrators]: true,
    [roles.clients]: false,
    [roles.experts]: false,
    [roles.none]: false,
    [roles.sales]: false,
  },
  me: {
    name: 'E',
    email: 'emmanuel.lambert-extern@renault.com',
  },
};
